import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Box, Container, Typography } from '@mui/material';

import Page from '../Page';
import Loading from '../../components/shared/Loading';
import MealPlanScheduleEditor from './MealPlanScheduleEditor';
import { useMutation, useQuery } from '@apollo/client/react';
import { GET_MEAL_PLAN, UPDATE_MEAL_PLAN } from '../../graphql/nutrition';
import ServerError from '../error/ServerError';
import config from '../../config';

const MealPlanEditor = () => {
  const { id } = useParams();
  const [mealPlan, setMealPlan] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const { error, loading, data } = useQuery(GET_MEAL_PLAN, {
    variables: { id },
  });
  const [updateMealPlan] = useMutation(UPDATE_MEAL_PLAN, {
    onError: (error) => {
      enqueueSnackbar(`Error: ${error.message}`, {
        variant: 'error',
        autoHideDuration: 2000,
      });
    },
  });

  useEffect(() => {
    setMealPlan(data?.mealPlan);
  }, [data]);

  const handleSave = (mealPlan) => {
    if (!mealPlan) {
      console.error('cant save, no meal plan input');
      return;
    }
    enqueueSnackbar('Saving...', { autoHideDuration: 2000 });
    updateMealPlan({
      variables: {
        id: mealPlan._id,
        input: {
          title: mealPlan.title,
          tags: mealPlan.tags,
          desc: mealPlan.desc,
          status: mealPlan.status,
          coverImages: mealPlan.coverImages || [],
          events: (mealPlan.events || []).map((event) => ({
            mealId: event.mealId || event.meal?._id || null,
            day: event.day ? parseInt(event.day, 10) : null,
            timeOfDay: event.timeOfDay,
          })),
        },
      },
    });
  };

  if (error) {
    return <ServerError message={error.message} />;
  }

  if (loading || !mealPlan) {
    return <Loading />;
  }

  return (
    <Page title={`MealPlan Editor : ${config.appDisplayName}`}>
      <Container maxWidth={false}>
        <Box mb={2}>
          <Typography sx={{ fontSize: 30, fontWeight: 800, color: '#071120' }}>
            Meal Plan
          </Typography>
        </Box>
        <MealPlanScheduleEditor mealPlan={mealPlan} onSave={handleSave} />
      </Container>
    </Page>
  );
};

export default MealPlanEditor;
